import React, { useState } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { PORTAL_URL } from '../../Constants';
import { useTranslation, Trans } from 'react-i18next';
const Offer = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const { t, i18n } = useTranslation();
    const servicesData = [
        {
            title: "Directory of Stakeholders",
            titleMr: "हितधारकांची निर्देशिका",
            description: "Provides access to detailed listings of housing societies service providers such as developers, PMC, Architect, Engineer, Advocate, Chartered Accountants, Suppliers, Contractors, Real Estate Agents others seeking redevelopment services and facilitates networking opportunities through seminars.",
            descriptionMr: "<strong> प्रकल्पासाठी आवश्यक असलेल्या भागधारकांची यादी व माहिती : </strong> हे गृहनिर्माण संस्थांसाठी सेवा पुरवणाऱ्या विविध भागधारकांची सविस्तर यादी GRSF च्या पोर्टलवर उपलब्ध आहे, ज्यामध्ये खालील भागधारकांचा समावेश आहे :विकासक (Developers), प्रकल्प व्यवस्थापन सल्लागार (PMC), वास्तुविशारद  (Architect), अभियंता (Engineer), परवानाधारक  सर्वेक्षक (License Surveyor), वकील (Advocate), सनदी लेखापाल (Chartered Accountants), विविध पुरवठादार (Suppliers), कंत्राटदार (Contractors), रिअल इस्टेट एजंट्स (Real Estate Agents) आणि पुनर्विकास सेवा शोधणाऱ्या इतर गृहनिर्माण संस्थांच्या सेवा प्रदात्यांच्या तपशीलवार यादीची सेवा प्रदान करते. याशिवाय, ही निर्देशिका नेटवर्किंग संधी निर्माण करण्यास देखील मदत करते, जसे की चर्चासत्रे, जे भागधारकांना  एकमेकांशी संपर्क साधण्याचा आणि सहकार्य करण्याची संधी उपलब्ध करून  देते.",
            imgSrc: "/images/home/services/1.jpg",
        },
        {
            title: "Awareness Programmes Events",
            titleMr: "जागरुकता कार्यक्रम व इव्हेंट्स",
            description: "Conducting seminars and awareness programmes either online or offline. Information booklets and newsletters giving clarity on the whole process of redevelopment.",
            descriptionMr: "<strong>पुनर्विकास प्रक्रियेबाबत</strong> जागरूकता निर्माण करण्यासाठी GRSF तर्फे ऑनलाईन तसेच ऑफलाईन पद्धतीने चर्चासत्रे व माहितीपर कार्यक्रम आयोजित केले जातात. पुनर्विकास प्रक्रियेची सखोल माहिती,  विविध टप्पे, कायदेशीर बाबी, कागदपत्रे व सर्वोत्तम पद्धती याबाबत मार्गदर्शन केले जाते. तसेच याबाबत माहिती पुस्तिका व वृत्तपत्रे याद्वारे माहिती देण्यात येते.",
            imgSrc: "/images/home/services/2.jpg",
        },
        {
            title: "Resources on Redevelopment",
            titleMr: "पुनर्विकासाविषयी संसाधने",
            description: "Latest Government Circulars, Notifications & Orders will be made available. FAQs on the process of redevelopment shall also be available.",
            descriptionMr: "GRSF पोर्टलवर शासन  अधिसूचना, परिपत्रके आणि आदेश उपलब्ध करून दिले जातात. पुनर्विकास प्रक्रियेबद्दल वारंवार विचारले जाणारे प्रश्न देखील उपलब्ध आहेत.",
            imgSrc: "/images/home/services/3.jpg",
        },
        {
            title: "Access to Model Draft Documents",
            titleMr: "नमुना मसुदा दस्तऐवजांचा प्रवेश",
            description: "Facilitates access to standardized legal documents, model agreements, and comprehensive documentation support, aiding societies and service providers in referring to draft agreements which are in compliance with legal standards.",
            descriptionMr: "GRSF व्यासपीठावर कायदेशीर मानकांनुसार तयार केलेल्या नमुना करारांचे व दस्तऐवजांचे संग्रहित स्वरूप उपलब्ध करून दिले जाते, जे संस्थांना  व सेवा पुरवठादारांना मार्गदर्शनासाठी अत्यंत उपयुक्त ठरतात.",
            imgSrc: "/images/home/services/4.jpg",
        },
        {
            title: "Judgements & Orders",
            titleMr: "महत्वाचे न्यायालयीन निकाल व आदेश ",
            description: "Latest Orders and Judgement from various authorities, High Court and Supreme Court related to redevelopment shall be made available",
            descriptionMr: "GRSF व्यासपीठावर  पुनर्विकासाशी संबंधित विविध प्राधिकरणांपासून ते उच्च न्यायालय व सर्वोच्च न्यायालयांपर्यंतचे महत्वाचे आदेश व न्यायनिर्णय उपलब्ध करून दिले जातील.",
            imgSrc: "/images/home/services/5.jpg",
        },
        {
            title: "Standard Operating Procedure (SOPs)",
            titleMr: "मानक कार्य प्रणाली  (SOP)",
            description: "Publish Standard Operating Procedure for each activity to be done in the redevelopment process, including the person responsible and tentative timelines for completing the activity.",
            descriptionMr: "GRSF पुनर्विकास प्रक्रियेतील प्रत्येक टप्प्यासाठी स्पष्ट व सुसंगत मानक कार्य प्रणाली (SOPs) प्रकाशित  केली जाईल,  ज्यामध्ये संबंधित जबाबदार  व्यक्तीचे नाव  व प्रत्येक  कार्याची अंदाजे पूर्णता कालमर्यादा यांचा समावेश असेल.",
            imgSrc: "/images/home/services/6.jpg",
        },
        {
            title: "Helpdesk and Guidance Cell",
            titleMr: "सहाय्यता  केंद्र आणि मार्गदर्शन कक्ष",
            description: "The Stakeholders (including Housing Society and its members) will be able to contact the Technical Officers & Experts for necessary help and guidance during the process of redevelopment.",
            descriptionMr: "पुनर्विकास प्रक्रियेदरम्यान आवश्यक मदत आणि मार्गदर्शनासाठी भागधारक (गृहनिर्माण संस्था आणि तिच्या सदस्यांसह) तांत्रिक अधिकारी व तज्ज्ञांशी थेट संपर्क साधून आवश्यक ती मदत व मार्गदर्शन घेऊ शकतात.",
            imgSrc: "/images/home/services/7.jpg",
        },
        {
            title: "Dispute Resolution (Upcoming)",
            titleMr: "वाद निवारण व्यवस्था (लवकरच उपलब्ध)",
            description: "Includes access to GRSF’s mediation and alternative dispute resolution mechanisms, assisting both service providers and societies in resolving conflicts efficiently and maintaining project continuity.",
            descriptionMr: "GRSF लवकरच मध्यस्थी व वैकल्पिक वाद निवारण यंत्रणा  सुरू करणार आहे, जी सेवा पुरवठादार आणि गृहनिर्माण संस्था यांना वाद सुसंवादाद्वारे सामंजस्याने सोडवण्यासाठी आणि प्रकल्पात  सातत्य राखण्यास मदत करेल.",
            imgSrc: "/images/home/services/8.jpg",
        },
        {
            title: "E-Tendering (Upcoming)",
            titleMr: "ई-निविदा (लवकरच उपलब्ध)",
            description: "Publication of redevelopment tenders and Tender for service providers on the portal.",
            descriptionMr: "GRSF पोर्टलवर लवकरच पुनर्विकास प्रकल्पांसाठी निविदा  प्रकाशित करण्याची सुविधा सुरु करण्यात येणार आहे.",
            imgSrc: "/images/home/services/9.jpg",
        },
        {
            title: "Project Monitoring Tools (Upcoming)",
            titleMr: "प्रकल्प देखरेख साधने (लवकरच उपलब्ध)",
            description: "Will provide advanced tools to track project progress and allow timely interventions, helping to keep redevelopment projects on track and within agreed timelines.",
            descriptionMr: "GRSF लवकरच प्रकल्पाच्या प्रगतीवर लक्ष ठेवण्यासाठी प्रगत देखरेख साधने   यांच्या वापरावर भर देणार आहे. त्यामुळे पुनर्विकास प्रकल्पांना नियोजित वेळेत आणि उद्दिष्टांनुसार  पूर्ण  करण्यास मदत होईल.",
            imgSrc: "/images/home/services/10.jpg",
        }
    ];

    const handleShow = (service) => {
        setSelectedService(service);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedService(null);
    };

    return (
        <>
            <section className='lyt-section custom-margin-top'>
                <div className='container'>
                    <div className='bs-breadcrumb'>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{t('servicesWeOffer')}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>

                    <div className='heading-wrapper'>
                        <h2 className='bs-heading typdblue mb-2' data-aos="fade-in" data-aos-delay="200">{t('servicesWeOffer')}</h2>
                        <p className='bs-para typgrey' data-aos="fade-in" data-aos-delay="300">{t('servicesWeOfferSubTitle')}</p>
                    </div>

                    <div className='row justify-content-center gy-5'>
                        {servicesData.map((service, index) => (
                            <div key={index} className='col-lg-4 col-md-6 col-12'>
                                <div className='bs-card typ-service' data-aos="fade-in" data-aos-delay={(index + 1) * 100}>
                                    <div className='box-img'>
                                        <img className="img-fluid" src={service.imgSrc} alt={service.title} width={384} height={297} />
                                    </div>
                                    <div className='box-text'>
                                        <div className='title'>{i18n.language === 'mr' ? service.titleMr : service.title}</div>
                                        <div
                                            className='discription'
                                            dangerouslySetInnerHTML={{
                                                __html: i18n.language === 'mr' ? service.descriptionMr : service.description
                                            }}
                                        />
                                        <div className='text-end'>
                                            <button
                                                className="bs-btn typexplore"
                                                aria-label="Explore More"
                                                onClick={() => handleShow(service)}
                                            >
                                                {t('exploreMore')}<span className="icon icon-right-arrow"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal */}
            <>
                <style>{`
    .bs-para {
      scrollbar-width: thin;
      scrollbar-color: #888 #f1f1f1;
    }
    .bs-para::-webkit-scrollbar {
      width: 8px;
    }
    .bs-para::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }
    .bs-para::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 4px;
      border: 2px solid #f1f1f1;
    }
  `}</style>

                <Modal
                    size="lg"
                    show={showModal}
                    onHide={handleClose}
                    centered
                    dialogClassName="custom-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {i18n.language === 'mr' ? selectedService?.titleMr : selectedService?.title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '1rem', display: 'flex', flexDirection: 'column'}}>
                        <img
                            src={selectedService?.imgSrc}
                            alt={selectedService?.title}
                            className="img-fluid mb-3"
                            style={{ maxHeight: '300px', objectFit: 'cover', width: '100%' }}
                        />
                        <div
                            className="bs-para typ-fw400 typ-16"
                            style={{
                                maxHeight: '6em',  
                                overflowY: 'auto',
                                paddingRight: '8px',
                                lineHeight: '1.2em', 
                            }}
                            dangerouslySetInnerHTML={{
                                __html: i18n.language === 'mr' ? selectedService?.descriptionMr : selectedService?.description,
                            }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <a className="bs-btn" href={PORTAL_URL} target="_blank" rel="noopener noreferrer">
                            {t('logIn')}
                        </a>
                    </Modal.Footer>
                </Modal>
            </>

        </>
    );
}

export default Offer;
